import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=c12af3c6"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports